<div class="wrapper-content" *ngIf="cont">
  <div class="cea-header">
    <div class="cea-banner" role="img" [attr.aria-label]="cont.altimage" magic [magicCss]="{type:'banner', background:api.getImageUrl(cont.image2) }"></div>
    <div class="cea-title">
      <div class="cea-brand">
        <img src="{{api.getImageUrl(cont.image) }}" alt="{{cont.altimage}}">
      </div>
      <h2>{{cont.title?.es}}
        <app-share [class]="'dark'" [name]="cont.title?.es"></app-share>

      </h2>
    </div>
  </div>
</div>
<app-widgets *ngIf="cont" [data]="cont"></app-widgets>

<app-footer></app-footer>
